import { useEffect, useState } from 'react'

function Confetti() {
  const [pieces, setPieces] = useState([])
  const colors = ['#F67443', '#FFC107', '#4CAF50', '#2196F3', '#9C27B0', '#E91E63']

  useEffect(() => {
    // Create confetti pieces
    const newPieces = []
    for (let i = 0; i < 300; i++) {
      newPieces.push({
        id: i,
        x: Math.random() * 100,
        y: -10 - Math.random() * 20,
        rotation: Math.random() * 360,
        size: 5 + Math.random() * 10,
        color: colors[Math.floor(Math.random() * colors.length)],
        speed: 2 + Math.random() * 3,
      })
    }
    setPieces(newPieces)

    // Animation loop
    const interval = setInterval(() => {
      setPieces((currentPieces) =>
        currentPieces.map((piece) => ({
          ...piece,
          y: piece.y + piece.speed,
          rotation: piece.rotation + 2,
          // Remove pieces that are off-screen and add new ones at the top
          ...(piece.y > 100
            ? {
                y: -10,
                x: Math.random() * 100,
                rotation: Math.random() * 360,
              }
            : {}),
        }))
      )
    }, 50)

    // Cleanup
    return () => clearInterval(interval)
  }, [])

  return (
    <div
      className="confetti-container"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        overflow: 'hidden',
        zIndex: 10,
      }}
    >
      {pieces.map((piece) => (
        <div
          key={piece.id}
          style={{
            position: 'absolute',
            left: `${piece.x}%`,
            top: `${piece.y}%`,
            width: `${piece.size}px`,
            height: `${piece.size}px`,
            backgroundColor: piece.color,
            transform: `rotate(${piece.rotation}deg)`,
            opacity: 0.8,
            borderRadius: Math.random() > 0.5 ? '50%' : '0%',
            zIndex: 10,
          }}
        />
      ))}
    </div>
  )
}

export default Confetti
